<template>
<main class="sa-content">
    <div v-if="refRevenue" class="sa-card-large">
        <revenue-details-view @close-pop="refRevenue = $event" />
    </div>
    <div v-else class="sa-card-large">
        <div class="sa-mob-header sa-header-bg">
            <h5 class="sa-card-tit">Report & Analysis</h5>
            <button class="sa-btn-back sa-h-sm-up" @click="$router.go(-1)">
                <i class="icon-arrow-left"></i>
            </button>
        </div>
        <div class="sa-tabs sa-btn-tabs">
            <a v-on:click="tabSelection='appointments'" v-bind:class="[ tabSelection === 'appointments' ? 'active' : '' ]">Appointments<i class="icon-right-arrow tab-icon sa-h-sm-up"></i></a>
            <a v-if="userDetails && userDetails.show_referral_screens" v-on:click="tabSelection='referral'" v-bind:class="[ tabSelection === 'referral' ? 'active' : '' ]">Referral<i class="icon-right-arrow tab-icon sa-h-sm-up"></i></a>
        </div>
        <div class="sa-tab-cont" :tabSelection="tabSelection">
            <div v-if="tabSelection === 'appointments'">
                <total-revenue-graph />
            </div>
            <div v-if="tabSelection === 'referral'">
                <revenue-details @close-pop="closePop" @refRevenue="refRevenue = $event" />
            </div>
        </div>
    </div>
</main>
</template>

<script>
import TotalRevenueGraph from "../../components/reportsv1/TotalRevenueGraph.vue";
import RevenueDetails from "../../components/reportsv1/RevenueDetails.vue";
import RevenueDetailsView from "../../components/reportsv1/RevenueDetailsView.vue";
export default {
    components: {
        TotalRevenueGraph,
        RevenueDetails,
        RevenueDetailsView
    },
    data() {
        return {
            isHidden: true,
            revDet: false,
            repAnal: true,
            userDetails: {},
            tabSelection: 'appointments',
            refRevenue: false
        };
    },
    mounted() {
        this.userDetails = JSON.parse(this.$localStorage.get("userdata"));
        this.toggleBodyClass("addClass", "sa-ref-bg");
    },
    methods: {
        viewDet() {
            this.revDet = true,
                this.repAnal = false
        },
        closePop() {
            this.revDet = false
            this.repAnal = true
        },
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;
            if (addRemoveClass === "addClass") {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
    },
    destroyed() {
        this.toggleBodyClass("removeClass", "sa-ref-bg");
    },
};
</script>
